<script setup>
import {defineProps} from 'vue'
import {useGlobalStore} from "@/stores";

const globals = useGlobalStore();

defineProps({
  job: {
    type: Object,
    default: () => ({})
  }
})
</script>

<template>
  <a v-if="job.slug" :href="globals.jobDetailBaseUrl + '/' + job.slug" class="job__offer_item-link" :class="{ 'karriereat': job.karriereAt }">
    <div class="job__offer_item-wrap">
      <div class="job__offer_item">
        <div class="job__offer-item-title bold" v-html="job.title"></div>
        <div class="job__offer-item-category"><template v-if="job.category">{{job.category.title}}</template></div>
        <div class="job__offer-item-location"><template v-if="job.location">{{job.location.title}}</template></div>
        <div class="job__offer-item-btn-wrap icon-arrow-right-after"></div>
      </div>
      <div class="job__offer-item-btn-wrap-mobile icon-arrow-right-after"></div>
    </div>
  </a>
</template>
